module.exports = __webpack_public_path__ + "static/M&S_selection3.12053fa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/M&S_selection3.jpg
// module id = 462
// module chunks = 35783957827783